import { createFileRoute } from "@tanstack/react-router";
import { kennelHomeRoute, KennelHomePage } from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/")({
    ssr: kennelHomeRoute.ssr,
    head: kennelHomeRoute.head,
    component: KennelHomePage,
});
